import type {
  FileAnalyticStatus,
  FileProcessResponse,
} from "@/features/upload/stores/upload/uploadSlice";
import { map } from "rxjs";
import HttpClient from "@/api/HttpClient";
import { APIHosts, ApiReduxHelpers } from "@/services/reduxHelpers";

export interface ExtractFileRequest {
  guid_file: string;
  path_file: string;
}

export interface FileAnalytic {
  _id: string;
  guid_file: string;
  name_file: string;
  path_file: string;
  path_file_processed: string;
  file_id_project: string;
  irai_id: string;
  type_extract: string;
}

class AnalyticApiController extends ApiReduxHelpers {
  constructor() {
    super();
  }

  ApiHost = APIHosts.DOCAI;
  ApiLabelHost = APIHosts.Analysis;
  public Post = {
    extractFileByPathFile: (data: ExtractFileRequest) => {
      const host = this.getHost(this.ApiHost);
      const url = `${host}/file/extract-file-by-path-file`;
      return HttpClient.post(url, data).pipe(
        map((res) => res as FileProcessResponse)
      );
    },
  };
  public Get = {
    getTaskByGuidFile: (guid_file: string) => {
      const host = this.getHost(this.ApiHost);
      const url = `${host}/task/guid_file/${guid_file}`;
      return HttpClient.get(url).pipe(map((res) => res as FileAnalyticStatus));
    },
  };
}

export const AnalyticService = new AnalyticApiController();
